import { Inject, Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class UiService {
    private _width: number = 0;
    private _height: number = 0;
    private _size: string = '';
    private _appMenuOpen: boolean = false;
    private _mainClasses: string = '';

    mainClasses: Subject<string> = new Subject<string>();
    appMenuOpen: Subject<boolean> = new Subject<boolean>();
    viewport: Subject<IViewport> = new Subject<IViewport>();
    skipLinkPath: string = '';

    appTitle: BehaviorSubject<string> = new BehaviorSubject<string>(
        'Loading...',
    );

    // Inject the Window object into window
    constructor(@Inject('Window') private window: Window) {
        this._width = window.innerWidth;
        this._height = window.innerHeight;
        this._size = this.getBootSize();
        this.appMenuOpen.next(this._appMenuOpen);
    }

    // Get the width of the window
    getWidth(): number {
        return this._width;
    }

    // Get the height of the window
    getHeight(): number {
        return this._height;
    }

    // Get the dimensions of the browser as an array
    getDimensions(): Array<number> {
        return [this._width, this._height];
    }

    // Get the name of Bootstrap size
    getBootSize(): string {
        if (this._width < 576) return 'xs';
        if (this._width >= 576 && this._width < 768) return 'sm';
        if (this._width >= 768 && this._width < 992) return 'md';
        if (this._width >= 992 && this._width < 1200) return 'lg';
        return 'xl';
    }

    setMainWidth(sizeClass: string): void {
        //this._mainClasses = 'main-' + sizeClass;
        if (sizeClass != '') {
            this.mainClasses.next('main-' + sizeClass);
        }
    }

    setAppMenu(isOpen: boolean): void {
        this._appMenuOpen = isOpen;
        this.appMenuOpen.next(isOpen);
    }

    isMenuOpen(): boolean {
        return this._appMenuOpen;
    }

    scrollToTop = () => {
        this.window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    setSkipLink(url: string): void {
        this.skipLinkPath = url;
    }

    getSkipLink(): string {
        return this.skipLinkPath;
    }

    // Returns a true/false response from the array of Bootstrap sizes ['md','lg'].
    checkSize(sizes: string[]): boolean {
        return sizes.some((size) => size == this._size);
    }

    // A function for setting the service's values when a resize event fires
    onResize(event: any) {
        this._width = event.target.innerWidth;
        this._height = event.target.innerHeight;
        this._size = this.getBootSize();
        this.viewport.next({
            width: this._width,
            height: this._height,
        });
    }

    setTitle(title: string): void {
        this.appTitle.next(title);
    }
}

export interface IAppMenu {
    open: boolean;
    activeApp: string;
}

export interface IViewport {
    width: number;
    height: number;
}
